import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  ProductCategory,
  ProductCategoryPayload,
} from "@project/types/gruh-udhyog";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/product-categories`;
const SILENT: RequestConfig = { showNotification: false };

class GruhUdhyogCategoryService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<ProductCategory>> =>
    fetchListPage<ProductCategory>(`${BASE}/`, query);

  get = async (id: number): Promise<ProductCategory | undefined> => {
    const data = await get<ApiItemResponse<ProductCategory> | ProductCategory>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: ProductCategoryPayload
  ): Promise<ProductCategory> => {
    const data = await post<
      ApiItemResponse<ProductCategory> | ProductCategory,
      ProductCategoryPayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create product category.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<ProductCategoryPayload>
  ): Promise<ProductCategory | undefined> => {
    const data = await patch<
      ApiItemResponse<ProductCategory> | ProductCategory,
      Partial<ProductCategoryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };

  listLookup = async (search = "") => {
    const result = await this.listPage({
      page: 1,
      page_size: 100,
      search: search || undefined,
      status: "active",
    });
    return result.data.map(item => ({
      value: String(item.id),
      label: item.category_name,
    }));
  };
}

export const gruhUdhyogCategoryService = new GruhUdhyogCategoryService();
